import React from 'react';
import {InputText} from 'primereact/inputtext';

interface CenteredInputTextProps {
  id: string;
  name: string;
  type: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder: string;
  label: string;
  icon: string;
  required?: boolean;
}

const CenteredInputText: React.FC<CenteredInputTextProps> = ({
  id,
  name,
  type,
  value,
  onChange,
  placeholder,
  label,
  icon,
  required = false
}) => {
  return (
    <div>
      <label htmlFor={id} className="block text-sm font-medium text-gray-700 mb-2">{label}</label>
      <div className="relative">
        <InputText
          id={id}
          name={name}
          type={type}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          required={required}
          className="w-full px-4 py-3 border border-gray-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-gray-800 focus:border-transparent transition duration-300"
        />
        <i className={`absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 ${icon}`}/>
      </div>
    </div>
  );
};

export default CenteredInputText;
